module.exports = __webpack_public_path__ + "94212788899bdc74179d6faed708a86a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alt_company_description.jpg
// module id = 166
// module chunks = 1